import React from "react";
import { toast } from "react-toastify";

import Modal from "../Modal";
import DataUpLogo from "../../assets/images/DataUpLogoAuth.svg";
import { useModal } from "../../context/ModalContext";
import NewPasswordForm from "../Form/NewPasswordForm";
const NewPasswordModal: React.FC = () => {
  const {
    isNewPasswordOpen,
    closeNewPasswordModal,
    openLoginModal,
    resetData,
  } = useModal();

  const email = resetData?.email || "";
  const token = resetData?.token || "";

  return (
    <Modal
      isOpen={isNewPasswordOpen}
      onClose={closeNewPasswordModal}
      className="h-[500px]  w-[484px]"
    >
      <div className="flex justify-center mb-4">
        <img
          src={DataUpLogo}
          alt="DatauplogoAuth"
          className="w-[135.55px] h-[32px]"
        />
      </div>
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">
        Set New Password
      </h2>
      <p className="text-gray-600 dark:text-gray-300">
        Create a strong password for your account
      </p>
      <NewPasswordForm
        isModal={true}
        onClose={closeNewPasswordModal}
        onSuccess={() => {
          toast.success(
            "Password successfully changed. Please, sign in with new password!"
          );
          closeNewPasswordModal();
          openLoginModal();
        }}
        email={email}
        token={token}
      />
    </Modal>
  );
};

export default NewPasswordModal;
